import React from 'react';
import './ImageShapeSelector.css';

const imageShapes = [
    {
        id: 'circle',
        name: 'Circle',
        className: 'image-shape-circle',
        preview: '●'
    },
    {
        id: 'organic-1',
        name: 'Organic Flow',
        className: 'image-shape-organic-1',
        preview: '◐'
    },
    {
        id: 'organic-3',
        name: 'Organic Wave',
        className: 'image-shape-organic-3',
        preview: '◒'
    },
    {
        id: 'rounded-square',
        name: 'Rounded Square',
        className: 'image-shape-rounded-square',
        preview: '▢'
    },
    {
        id: 'diagonal-rounded',
        name: 'Diagonal Rounded',
        className: 'image-shape-diagonal-rounded',
        preview: '◪'
    },
    {
        id: 'circle-chill',
        name: 'Circle Chill',
        className: 'image-shape-circle image-shape-chill-pulse',
        preview: '◉'
    },
    {
        id: 'organic-chill',
        name: 'Organic Zen',
        className: 'image-shape-organic-1 image-shape-chill-morph',
        preview: '〰'
    }
];

function ImageShapeSelector({ selectedShape, onShapeChange, label = "Image Shape" }) {
    return (
        <div className="image-shape-selector-container">
            <label className="shape-selector-label">{label}</label>
            <div className="shape-selector-grid">
                {imageShapes.map((shape) => (
                    <button
                        key={shape.id}
                        type="button"
                        className={`shape-selector-button ${selectedShape === shape.id ? 'selected' : ''}`}
                        onClick={() => onShapeChange(shape.id)}
                        title={shape.name}
                    >
                        <div className={`shape-preview ${shape.className}`}>
                            <span className="shape-preview-symbol">{shape.preview}</span>
                        </div>
                        <span className="shape-name">{shape.name}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}

export { imageShapes };
export default ImageShapeSelector;
